import * as Yup from "yup";

const schema = Yup.object({
  accountHolderName: Yup.string().required("Account holder name is required").trim(),
  bankName: Yup.string().required("Bank name is required").trim(),
  branchName: Yup.string().nullable().optional().trim(),
  accountNumber: Yup.string().required("Account number is required").trim(),
  ifscCode: Yup.string()
    .required("IFSC code is required")
    .transform((v) =>
      v == null || v === "" ? v : String(v).trim().toUpperCase(),
    )
    .length(11, "IFSC must be exactly 11 characters"),
  isPrimary: Yup.boolean().optional(),
});

export default schema;
